<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg viewBox="0 0 24 24" {...rest} width={size * 4} height={size * 4} class={className}>
  {#if title}<title>{title}</title>{/if}
  <path
    d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V6C7 5.45 7.196 4.97933 7.588 4.588C7.97933 4.196 8.45 4 9 4H12.5C13.6333 4 14.625 4.325 15.475 4.975C16.325 5.625 16.75 6.51667 16.75 7.65C16.75 8.45 16.5667 9.08733 16.2 9.562C15.8333 10.0373 15.4 10.4 14.9 10.65V10.85C15.6333 11.1 16.2083 11.4917 16.625 12.025C17.0417 12.5583 17.25 13.25 17.25 14.1C17.25 15.35 16.7957 16.3127 15.887 16.988C14.979 17.6627 13.9 18 12.65 18H9ZM9.65 9.7H12.3C12.85 9.7 13.3043 9.54167 13.663 9.225C14.021 8.90833 14.2 8.50833 14.2 8.025C14.2 7.54167 14.021 7.14167 13.663 6.825C13.3043 6.50833 12.85 6.35 12.3 6.35H9.65V9.7ZM9.65 15.6H12.5C13.15 15.6 13.6627 15.4333 14.038 15.1C14.4127 14.7667 14.6 14.325 14.6 13.775C14.6 13.225 14.4127 12.7833 14.038 12.45C13.6627 12.1167 13.15 11.95 12.5 11.95H9.65V15.6Z"
    fill="currentColor"
  />
</svg>
